import { BaseControl } from "./BaseControl";
import { Controller } from "./Controller";
import { app } from "../Frame/App";

export class DateControl extends BaseControl {
    private datePicker: JQuery<HTMLElement>;
    private oldValue: Date;

    postSaveValue: (savedValue: string) => void;
    useDate: boolean = false;
    useDateType: boolean = false;

    constructor(protected input: HTMLInputElement, controller: Controller, field: string) {
        super(controller, field);

        input.type = "date";
        //input.setAttribute("data-date-format", "dd/mm/yyyy");
        //if (app.defaultLanguage == "de")
        //    input.setAttribute("data-date-language", "de");
        //else
        //    input.setAttribute("data-date-language", "en");

        /*input.setAttribute("data-provide", "datepicker");*/

        if (controller.automaticUpdateModel) {
            // save new value on lost focus
            input.addEventListener("blur", this.onBlur);

            // save new value on return
            input.addEventListener("keydown", this.onKeyDown);
        }
    }

    clearValue = () => {
        this.input.value = null;
    }

    saveValue = (value: string) => {
        if (this.useDateType) {
            if (this.input.value) {
                let dateObject = new Date(this.input.value);
                this.model.dateValue = dateObject;
            } else {
                this.model.dateValue = null;
            }
        }
        else if (this.useDate) {
            let date = this.input.value;
            this.setModelValue(date);
        } else {
            this.updateModelFromControl();
        }

        if (this.postSaveValue) {
            this.postSaveValue(value);
        }

        this.controller.dispatchOnSave({
            id: this.model.id,
            model: this.model,
            properties: [
                {
                    field: this.field,
                    value: this.getModelValue()
                }
            ]
        });
    }

    onBlur = (ev: Event) => {
        this.saveValue(this.input.value);
    }

    onKeyDown = (ev: KeyboardEvent) => {
        if (ev.keyCode == 13) {
            this.saveValue(this.input.value);
        }
    }

    dispose() {
        this.input.removeEventListener("blur", this.onBlur);
        this.input.removeEventListener("keydown", this.onKeyDown);
    }

    updateControlFromModel() {
        let value = this.getModelValue();

        if (value && typeof value === 'string') {
            console.log(`BindingControls.DateControl: value '${value}' is is a string.`);
            this.input.value = value.substring(0, 10);
        }
        else if (value
            // Weird javascript way to test if a date is valid
            && value instanceof Date
            && (value.getTime() === value.getTime())) {

            this.input.value = value.toISOString().substring(0, 10);

        } else {
            this.input.value = "";
        }
    }

    updateModelFromControl() {
        let date = this.input.value;
        if (date) {
            date = new Date(date).toISOString().substring(0, 10);
        }
        this.setModelValue(date);
    }

    validate() {
    }

    focus() {
        this.input.focus();
    }
}
